
namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MixingDialog extends Serenity.EntityDialog<MixingRow, any> {
        protected getFormKey() { return MixingForm.formKey; }
        protected getIdProperty() { return MixingRow.idProperty; }
        protected getLocalTextPrefix() { return MixingRow.localTextPrefix; }
        protected getNameProperty() { return MixingRow.nameProperty; }
        protected getService() { return MixingService.baseUrl; }
        protected getDeletePermission() { return MixingRow.deletePermission; }
        protected getInsertPermission() { return MixingRow.insertPermission; }
        protected getUpdatePermission() { return MixingRow.updatePermission; }
        protected useViewMode() { return true; }
        protected form = new MixingForm(this.idPrefix);
        public Closing: boolean;

        constructor() {
            super();
            //Make grid full width
            
            q.hideEditorLabel(this.form.Details);
            q.hideEditorLabel(this.form.ItemsDetails);
            q.setGridEditorHeight(this.form.ItemsDetails, 300);
            q.setGridEditorHeight(this.form.Details, 300);
            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategorySixColumn(this.form.VoucherTypeId);
            q.SetCategoryFullWidth(this.form.Details);

            q.hideEditorLabel(this.form.ItemsDetails);
            q.HideCategoryLable(this.element);
            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
                var lotno = this.form.Details.getItems()[0].LotNo;
                this.form.ItemsDetails.Lotno = lotno;

            });

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Inventory:Mixing:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    MixingService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                Stock.StockItemService.CheckTransaction(
                    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            refid = response.Entities[0];
                    }, { async: false }
                )
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                    this.form.Details.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        MixingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }
        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('export-pdf-button').toggle(this.isEditMode());
            if (this.entity.IsPosted) {
                this.toolbar.findButton('approve-doc-button').toggle(true);
                this.form.Posted.setText("Posted");
                this.form.Posted.element.addClass("btn btn-info btn-sm");

                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
            }
            else {
                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
                this.form.Posted.setText("Not Posted");
                this.form.Posted.element.addClass("btn btn-warning btn-sm");
                if (this.isNew())
                    q.hideField(this.form.Posted);
            }

        }
    }
}